import { useState, useEffect } from "react";
import { getPublicSEO } from "@/lib/api";

const seoCache = {};

export function useSEO(pageSlug, fallback = {}) {
  const [seo, setSeo] = useState(fallback);

  useEffect(() => {
    if (seoCache[pageSlug]) {
      setSeo((prev) => mergeSEO(seoCache[pageSlug], prev));
      return;
    }
    getPublicSEO(pageSlug)
      .then((data) => {
        seoCache[pageSlug] = data;
        setSeo((prev) => mergeSEO(data, prev));
      })
      .catch(() => {});
  }, [pageSlug]);

  return seo;
}

function mergeSEO(fetched, fallback) {
  const merged = { ...fallback };
  for (const [key, val] of Object.entries(fetched)) {
    if (val) merged[key] = val;
  }
  return merged;
}
